import React from "react";
import { useFormikContext } from "formik";
import { Input } from "./input";
import { usePendingPrefill, useSetDefaultValue } from "@hooks/index";
import { emptyFunction } from "@utils/helpers/emptyFunction";

export const PrefillInput = React.forwardRef((props, ref) => {
  const { 
    name, title, placeholder, type, maxLength, inputMode, prefix, toolTipText, customClass, onBlur 
  } = props;
  const { handleChange, handleBlur, values, errors, touched } = useFormikContext();
  
  useSetDefaultValue(name);
  usePendingPrefill(name);

  return (
    <Input
      ref={ref}
      title={title}
      placeholder={placeholder}
      onChange={handleChange}
      onBlur={(event) => {
        handleBlur(event);
        (onBlur || emptyFunction)(event);
      }}
      value={values[name]}
      name={name}
      type={type}
      maxLength={maxLength}
      inputMode={inputMode}
      prefix={prefix}
      toolTipText={toolTipText}
      customClass={customClass}
      errorMessage={touched[name] ? errors[name] : ""}
    />
  );
});